import NcCard from './NcCard.vue';
import NcListItem from './NcListItem.vue';
import NcInput from './NcInput.vue';
import NcTextarea from './NcTextarea.vue';
import NcSelect from './NcSelect.vue';
import NcChip from './NcChip.vue';
import NcButton from './NcButton.vue';
import NcModal from './NcModal.vue';
import NcDragList from './NcDragList.vue';
import NcAlert from './NcAlert.vue';
import NcEmptyState from './NcEmptyState.vue';
import NcTabs from './NcTabs.vue';
import NcPage from './NcPage.vue';
import NcHeader from './NcHeader.vue';
import NcContent from './NcContent.vue';
import NcFooter from './NcFooter.vue';
import NcToggle from './NcToggle.vue';
import NcCheckbox from './NcCheckbox.vue';
import NcRadio from './NcRadio.vue';
import NcProgressBar from './NcProgressBar.vue';
import NcSearchBar from './NcSearchBar.vue';
import NcAccordion from './NcAccordion.vue';
import NcBadge from './NcBadge.vue';
import NcSpinner from './NcSpinner.vue';
import NcPopover from './NcPopover.vue';
import NcDatePicker from './NcDatePicker.vue';
import NcFormField from './NcFormField.vue';
import NcStepper from './NcStepper.vue';

const components = {
  NcCard,
  NcListItem,
  NcInput,
  NcTextarea,
  NcSelect,
  NcChip,
  NcButton,
  NcModal,
  NcDragList,
  NcAlert,
  NcEmptyState,
  NcTabs,
  NcPage,
  NcHeader,
  NcContent,
  NcFooter,
  NcToggle,
  NcCheckbox,
  NcRadio,
  NcProgressBar,
  NcSearchBar,
  NcAccordion,
  NcBadge,
  NcSpinner,
  NcPopover,
  NcDatePicker,
  NcFormField,
  NcStepper,
};

export default {
  install(app) {
    for (const [name, component] of Object.entries(components)) {
      app.component(name, component);
    }
  },
};

export {
  NcCard,
  NcListItem,
  NcInput,
  NcTextarea,
  NcSelect,
  NcChip,
  NcButton,
  NcModal,
  NcDragList,
  NcAlert,
  NcEmptyState,
  NcTabs,
  NcPage,
  NcHeader,
  NcContent,
  NcFooter,
  NcToggle,
  NcCheckbox,
  NcRadio,
  NcProgressBar,
  NcSearchBar,
  NcAccordion,
  NcBadge,
  NcSpinner,
  NcPopover,
  NcDatePicker,
  NcFormField,
  NcStepper,
};
